import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { __privateAdd, __privateGet, __privateMethod, __privateSet } from "./chunk-PXG64RU4.js"; // src/queriesObserver.ts

import { notifyManager } from "./notifyManager.js";
import { QueryObserver } from "./queryObserver.js";
import { Subscribable } from "./subscribable.js";
import { replaceEqualDeep } from "./utils.js";

function difference(array1, array2) {
  return array1.filter(function (x) {
    return !array2.includes(x);
  });
}

function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}

var _client, _result, _queries, _options, _observers, _combinedResult, _lastCombine, _lastResult, _observerMatches, _QueriesObserver_instances, trackResult_fn, combineResult_fn, findMatchingObservers_fn, onUpdate_fn, notify_fn;

var QueriesObserver = /*#__PURE__*/function (_Subscribable) {
  function QueriesObserver(client, queries, options) {
    var _this2;

    _classCallCheck(this, QueriesObserver);

    _this2 = _callSuper(this, QueriesObserver);

    __privateAdd(_this2, _QueriesObserver_instances);

    __privateAdd(_this2, _client);

    __privateAdd(_this2, _result);

    __privateAdd(_this2, _queries);

    __privateAdd(_this2, _options);

    __privateAdd(_this2, _observers);

    __privateAdd(_this2, _combinedResult);

    __privateAdd(_this2, _lastCombine);

    __privateAdd(_this2, _lastResult);

    __privateAdd(_this2, _observerMatches, []);

    __privateSet(_this2, _client, client);

    __privateSet(_this2, _options, options);

    __privateSet(_this2, _queries, []);

    __privateSet(_this2, _observers, []);

    __privateSet(_this2, _result, []);

    _this2.setQueries(queries);

    return _this2;
  }

  _inherits(QueriesObserver, _Subscribable);

  return _createClass(QueriesObserver, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      var _this3 = this;

      if (this.listeners.size === 1) {
        __privateGet(this, _observers).forEach(function (observer) {
          observer.subscribe(function (result) {
            __privateMethod(_this3, _QueriesObserver_instances, onUpdate_fn).call(_this3, observer, result);
          });
        });
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.listeners.size) {
        this.destroy();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners = /* @__PURE__ */new Set();

      __privateGet(this, _observers).forEach(function (observer) {
        observer.destroy();
      });
    }
  }, {
    key: "setQueries",
    value: function setQueries(queries, options) {
      var _this4 = this;

      __privateSet(this, _queries, queries);

      __privateSet(this, _options, options);

      if (process.env.NODE_ENV !== "production") {
        var queryHashes = queries.map(function (query) {
          return __privateGet(_this4, _client).defaultQueryOptions(query).queryHash;
        });

        if (new Set(queryHashes).size !== queryHashes.length) {
          console.warn("[QueriesObserver]: Duplicate Queries found. This might result in unexpected behavior.");
        }
      }

      notifyManager.batch(function () {
        var prevObservers = __privateGet(_this4, _observers);

        var newObserverMatches = __privateMethod(_this4, _QueriesObserver_instances, findMatchingObservers_fn).call(_this4, __privateGet(_this4, _queries));

        __privateSet(_this4, _observerMatches, newObserverMatches);

        newObserverMatches.forEach(function (match) {
          return match.observer.setOptions(match.defaultedQueryOptions);
        });
        var newObservers = newObserverMatches.map(function (match) {
          return match.observer;
        });
        var newResult = newObservers.map(function (observer) {
          return observer.getCurrentResult();
        });
        var hasIndexChange = newObservers.some(function (observer, index) {
          return observer !== prevObservers[index];
        });

        if (prevObservers.length === newObservers.length && !hasIndexChange) {
          return;
        }

        __privateSet(_this4, _observers, newObservers);

        __privateSet(_this4, _result, newResult);

        if (!_this4.hasListeners()) {
          return;
        }

        difference(prevObservers, newObservers).forEach(function (observer) {
          observer.destroy();
        });
        difference(newObservers, prevObservers).forEach(function (observer) {
          observer.subscribe(function (result) {
            __privateMethod(_this4, _QueriesObserver_instances, onUpdate_fn).call(_this4, observer, result);
          });
        });

        __privateMethod(_this4, _QueriesObserver_instances, notify_fn).call(_this4);
      });
    }
  }, {
    key: "getCurrentResult",
    value: function getCurrentResult() {
      return __privateGet(this, _result);
    }
  }, {
    key: "getQueries",
    value: function getQueries() {
      return __privateGet(this, _observers).map(function (observer) {
        return observer.getCurrentQuery();
      });
    }
  }, {
    key: "getObservers",
    value: function getObservers() {
      return __privateGet(this, _observers);
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(queries, combine) {
      var _this5 = this;

      var matches = __privateMethod(this, _QueriesObserver_instances, findMatchingObservers_fn).call(this, queries);

      var result = matches.map(function (match) {
        return match.observer.getOptimisticResult(match.defaultedQueryOptions);
      });
      return [result, function (r) {
        return __privateMethod(_this5, _QueriesObserver_instances, combineResult_fn).call(_this5, r !== null && r !== void 0 ? r : result, combine);
      }, function () {
        return __privateMethod(_this5, _QueriesObserver_instances, trackResult_fn).call(_this5, result, matches);
      }];
    }
  }]);
}(Subscribable);

_client = new WeakMap();
_result = new WeakMap();
_queries = new WeakMap();
_options = new WeakMap();
_observers = new WeakMap();
_combinedResult = new WeakMap();
_lastCombine = new WeakMap();
_lastResult = new WeakMap();
_observerMatches = new WeakMap();
_QueriesObserver_instances = new WeakSet();

trackResult_fn = function trackResult_fn(result, matches) {
  return matches.map(function (match, index) {
    var observerResult = result[index];
    return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, function (accessedProp) {
      matches.forEach(function (m) {
        m.observer.trackProp(accessedProp);
      });
    }) : observerResult;
  });
};

combineResult_fn = function combineResult_fn(input, combine) {
  if (combine) {
    if (!__privateGet(this, _combinedResult) || __privateGet(this, _result) !== __privateGet(this, _lastResult) || combine !== __privateGet(this, _lastCombine)) {
      __privateSet(this, _lastCombine, combine);

      __privateSet(this, _lastResult, __privateGet(this, _result));

      __privateSet(this, _combinedResult, replaceEqualDeep(__privateGet(this, _combinedResult), combine(input)));
    }

    return __privateGet(this, _combinedResult);
  }

  return input;
};

findMatchingObservers_fn = function findMatchingObservers_fn(queries) {
  var _this6 = this;

  var prevObserversMap = new Map(__privateGet(this, _observers).map(function (observer) {
    return [observer.options.queryHash, observer];
  }));
  var observers = [];
  queries.forEach(function (options) {
    var defaultedOptions = __privateGet(_this6, _client).defaultQueryOptions(options);

    var match = prevObserversMap.get(defaultedOptions.queryHash);

    if (match) {
      observers.push({
        defaultedQueryOptions: defaultedOptions,
        observer: match
      });
    } else {
      observers.push({
        defaultedQueryOptions: defaultedOptions,
        observer: new QueryObserver(__privateGet(_this6, _client), defaultedOptions)
      });
    }
  });
  return observers;
};

onUpdate_fn = function onUpdate_fn(observer, result) {
  var index = __privateGet(this, _observers).indexOf(observer);

  if (index !== -1) {
    __privateSet(this, _result, replaceAt(__privateGet(this, _result), index, result));

    __privateMethod(this, _QueriesObserver_instances, notify_fn).call(this);
  }
};

notify_fn = function notify_fn() {
  var _this7 = this;

  var _a;

  if (this.hasListeners()) {
    var previousResult = __privateGet(this, _combinedResult);

    var newTracked = __privateMethod(this, _QueriesObserver_instances, trackResult_fn).call(this, __privateGet(this, _result), __privateGet(this, _observerMatches));

    var newResult = __privateMethod(this, _QueriesObserver_instances, combineResult_fn).call(this, newTracked, (_a = __privateGet(this, _options)) == null ? void 0 : _a.combine);

    if (previousResult !== newResult) {
      notifyManager.batch(function () {
        _this7.listeners.forEach(function (listener) {
          listener(__privateGet(_this7, _result));
        });
      });
    }
  }
};

export { QueriesObserver };